import { Component, Input, Output, EventEmitter } from '@angular/core';

import { DxDataGridComponent, DxPivotGridComponent } from 'devextreme-angular';

import { GridService, MessageService } from 'kmm-corp-api';

@Component({
   selector: 'app-modelo-grid-form-component',
   templateUrl: './modelo-grid.form.html'
})
export class ModeloGridFormComponent {

   @Input() contextName: string;
   @Input() dxDataGrid: DxDataGridComponent;
   @Input() dxPivotGrid: DxPivotGridComponent;
   @Output() saveAction: EventEmitter<any> = new EventEmitter();

   visible: boolean = false;
   model: any = { descricao: '', padrao: false };

   constructor(
      protected _gridService: GridService,
      protected _messageService: MessageService
   ) {
   }

   onHidden() {
      this.cancel();
   }

   cancel() {
      this.visible = false;
      this.model = { descricao: '', padrao: false };
   }

   saveModelo(ev) {
      let state = null;

      if (this.dxDataGrid) {
         state = this.dxDataGrid.instance.state();
      }

      if (this.dxPivotGrid) {
         state = this.dxPivotGrid.instance.getDataSource().state();
      }

      const params = {
         grid_ref: this.contextName,
         colunas: JSON.stringify(state)
      };
      Object.assign(params, this.model);

      this._gridService.saveModelo(params).subscribe(res => {
         this.visible = false;
         this.model = { descricao: '', padrao: false };

         if (params['padrao']) {
            localStorage.removeItem(params['grid_ref']);
         }

         this.saveAction.emit(params);
      });
   }

}
